<template lang="html">
  <div class="conversion-privilege">
    <h1>{{title}}</h1>
    <div class="privilege" @click="$router.push('privilege')">
      <!--如果有优惠价格则显示-->
      <div class="privilege-desc" >
        <p v-if="discountPrice < price">现在升级，<span>可省{{(price * 1000 - discountPrice * 1000)/1000}}元</span></p>
        <p>一天只需{{discountPrice < price ? (discountPrice/365).toFixed(2) : (price/365).toFixed(2)}}元</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConversionPrivilege',
  props: ['price', 'discountPrice'],
  computed: {
    title () {
      return this.discountPrice < this.price ? '- 限时升级畅学卡 -' : '- 升级畅学卡 -'
    }
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.conversion-privilege {
  margin-bottom: rem(55);
  h1 {
    color: #666666;
    font-size: rem(24);
    text-align: center;
    margin-bottom: rem(25);
  }
  .privilege {
    width: rem(680);
    height: rem(360);
    margin: auto;
    background-image: url("./images/privilege.png");
    background-size: 100% 100%;
    position: relative;
    box-shadow: rgba(#2E3748, .21) rem(0) rem(12) rem(14) rem(0);
    border-radius: rem(20);
    &-desc {
      position: absolute;
      right: rem(45);
      top: rem(164);
      font-size: rem(22);
      color: #C4CEE0;
      text-align: right;
      line-height: 1.2;
      span {
        color: #F2E6C4;
      }
    }
  }
}
</style>
